import { render, staticRenderFns } from "./VueClock.vue?vue&type=template&id=7b8afa62&scoped=true"
import script from "./VueClock.vue?vue&type=script&lang=js"
export * from "./VueClock.vue?vue&type=script&lang=js"
import style0 from "./VueClock.vue?vue&type=style&index=0&id=7b8afa62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8afa62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8afa62')) {
      api.createRecord('7b8afa62', component.options)
    } else {
      api.reload('7b8afa62', component.options)
    }
    module.hot.accept("./VueClock.vue?vue&type=template&id=7b8afa62&scoped=true", function () {
      api.rerender('7b8afa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueClock/VueClock.vue"
export default component.exports